export default __webpack_public_path__ + "static/media/github.6fa0c3b0.svg";